const globalTitle = {
  DASHBOARD: 'DASHBOARD',
  Interactive_Ads: 'Interactive_Ads',
  ADVERTISER: 'ADVERTISER',
  OFFER: 'OFFER',
  AFFILIATE: 'AFFILIATE',
  PERMISSION: 'PERMISSION',
  SETTING: 'SETTING',
  REPORT: 'REPORT',
  FINANCE: 'FINANCE',
  TRAFFIC_QUALITY: 'TRAFFIC_QUALITY',
  OFFER_DETECT: 'OFFER_DETECT',
  FEEDBACK: 'FEEDBACK',
  PUSHGO: 'PUSHGO',
  WEBSITE_MANAGEMENT: 'WEBSITE_MANAGEMENT',
  ONLINE_EARNING: 'ONLINE_EARNING',
  SDK: 'SDK',
  SELF_SERVICE: 'SELF_SERVICE',
  OPPO_Reach: 'OPPO_Reach',
}

export default globalTitle
